import { Request } from './Request';

export interface IGetZiplogInfoParams {
}

export interface IGetZiplogInfoResult {
  status: string; // one of ['none', 'inprogress', 'complete']
  date?: string; // datetime(ISO 8601 UTC): YYYY-MM-DDThh:mm:ssZ
  size?: number; // bytes
}

export class GetZiplogInfoRequest extends Request<IGetZiplogInfoParams, IGetZiplogInfoResult> {
  constructor(params: IGetZiplogInfoParams = {}) {
    super('getZiplogInfo', params);
  }
}
